import { industriesData } from '../../../mocks/industries';

export default function Industries() {
  return (
    <section id="industries" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
            Industries We <span className="text-red-500">Serve</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Specialized marketing solutions tailored for contractors across multiple trades
          </p>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {industriesData.map((industry) => (
            <a
              key={industry.id}
              href={`/industries/${industry.name.toLowerCase().replace(/\s+/g, '-')}`}
              className="group relative overflow-hidden rounded-lg shadow-lg cursor-pointer h-80 bg-black"
            >
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full">
                <img
                  src={industry.image}
                  alt={`${industry.name} services`}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                />
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/60 group-hover:bg-black/70 transition-all duration-300"></div>
              </div>

              {/* Content */}
              <div className="relative h-full flex flex-col justify-end p-8 z-10">
                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center mb-4">
                  <i className={`${industry.icon} text-5xl text-red-500 group-hover:scale-110 transition-transform duration-300`}></i>
                </div>

                {/* Industry Name */}
                <h3 className="text-3xl font-bold text-white mb-2 group-hover:text-red-500 transition-colors duration-300">
                  {industry.name}
                </h3>

                {/* Arrow Icon */}
                <div className="flex items-center text-white group-hover:text-red-500 transition-colors duration-300">
                  <span className="text-sm font-semibold mr-2">Learn More</span>
                  <i className="ri-arrow-right-line text-xl group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-6">
            Don't see your industry? We work with all types of contractors.
          </p>
          <a
            href="#contact"
            className="inline-block bg-red-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Get Your Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}
